<template>
  <yd-layout>
    <yd-accordion>
      <yd-accordion-item>
        <div style="padding: .24rem;" class="nav_box">
          <div v-for="term of termList" :key="term.id">
            <a :href="'/'+fairDetail.id+'/'+term.url" class="nav">{{term.name}}</a>
          </div>
        </div>
      </yd-accordion-item>
    </yd-accordion>
    <!-- 图片区域 -->
    <div class="warp">
      <img :src="fairDetail.mimg">
    </div>
    <!-- 图片区域结束 -->
    <yd-tabbar slot="tabbar">
      <yd-tabbar-item
        v-for="(item, key) in footer"
        :key="key"
        :title="item.title"
        :link="item.link"
        :active="item.active"
        v-model="footer"
        @click.native="activeCheck"
      >
        <yd-icon :name="item.icon" slot="icon" size="0.54rem"></yd-icon>
      </yd-tabbar-item>
    </yd-tabbar>
  </yd-layout>
</template>
<script>
import axios from 'axios'
import wx from 'weixin-js-sdk'

export default {
  data () {
    return {
      termList: [],
      fairDetail: [],
      xuzhi: [],
      backgroupData: [],
      params: this.$route.params,
      footer: [
        {
          icon: 'home',
          title: '首页',
          ident: 'home',
          link: '/' + this.$route.params.id + '/my?code=' + this.$route.query.code,
          active: true
        },
        {
          icon: 'compose',
          title: '报名',
          ident: 'fair-buy',
          link: '/' + this.$route.params.id + '/fair-buy',
          active: false
        },
        {
          icon: 'ucenter-outline',
          title: '个人中心',
          ident: 'single-my',
          link: '/' + this.$route.params.id + '/single-my',
          active: false
        }
      ],
      style: {}
    }
  },
  methods: {
    activeCheck () {
      this.footer.forEach(item => {
        if (item.link === this.$route.fullPath) {
          item.active = true
        } else {
          item.active = false
        }
      })
    },
    getFairDetail () {
      if (this.$route.query.code && this.$route.query.code !== 'undefined') {
        localStorage.setItem('code', this.$route.query.code)
      }
      let data = {id: this.params.id, limit: 20}
      axios
        .post('/fair/fair-detail', data)
        .then(this.getFairDetailSucc)
    },
    getFairDetailSucc (res) {
      res = res.data
      if (res.status && res.data) {
        this.termList = res.data.termList
        this.fairDetail = res.data.fair
        localStorage.setItem('fair_name', this.fairDetail.fair_name)
        localStorage.setItem('fair_id', this.fairDetail.id)
        document.title = this.fairDetail.fair_name
        this.xuzhi = res.data.system
        this.weixinshare()
      } else {
        // this.$dialog.alert({mes: '会议不存在'})
      }
    },
    HistoryBack () {
      window.history.back()
    },
    weixinshare () {
      let data = {fairid: this.params.id, url: window.location.href}
      axios
        .post('/fair/weixinfx', data)
        .then(res => {
          let datafx = res.data
          wx.config({
            debug: false,
            appId: datafx.data.appId,
            timestamp: datafx.data.timestamp,
            nonceStr: datafx.data.nonceStr,
            signature: datafx.data.signature,
            jsApiList: [
              // 所有要调用的 API 都要加到这个列表中
              'checkJsApi',
              'openLocation',
              'getLocation',
              'onMenuShareTimeline',
              'onMenuShareAppMessage'
            ]
          })
          wx.ready(function () {
            wx.onMenuShareAppMessage({
              title: this.fairDetail.sharetitle,
              desc: this.fairDetail.sharedescription,
              link: window.location.href,
              imgUrl: this.fairDetail.shareimg,
              trigger: function (res) {
                // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回
                // alert('用户点击发送给朋友');
              },
              success: function (res) {
                // alert('已分享');
              },
              cancel: function (res) {
                // alert('已取消');
              },
              fail: function (res) {
                // alert(JSON.stringify(res));
              }
            })

            wx.onMenuShareTimeline({
              title: this.fairDetail.sharetitle,
              desc: this.fairDetail.sharedescription,
              link: window.location.href,
              imgUrl: this.fairDetail.shareimg,
              trigger: function (res) {
                // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回
                // alert('用户点击分享到朋友圈');
              },
              success: function (res) {
                // alert('已分享');
              },
              cancel: function (res) {
                // alert('已取消');
              },
              fail: function (res) {
                // alert(JSON.stringify(res));
              }
            })
          })
        })
    }
  },
  mounted () {
    this.getFairDetail()
    this.activeCheck()
  },
  watch: {
    $route (to, from) {
      this.activeCheck()
    }
  }
}
</script>

<style lang="stylus" scoped>
  .bottom {
    position: absolute;
    bottom: 0;
    width: 100%;
  }

  .fariinfo {
    margin: .3rem;
  }

  .fariinfo h3 {
    line-height: 1.5;
    font-size: .45rem;
  }

  .fariinfo p {
    line-height: 2;
    font-size: .3rem;
  }

  .yd-flexview
    max-width: 1920px !important

  .yd-grids-item::after
    display: none

  .yd-grids-item::before
    display: none
  .warp
    width: 100%
    overflow: hidden
  .warp img
    max-width: 100%
    width: 100%
  .yd-accordion
    position: fixed
    background: none
    right: 0
    top: .6rem
  .nav_box
    padding: .2rem .4rem!important
    margin-right: .4rem
    background-color: rgba(255,255,255,0.9)
    border-radius: .1rem
    position relative
  .nav
    position: relative
    color: #333
    line-height: .6rem
  .nav::after
    content: ""
    width: calc(100% + .4rem)
    height : 1px
    background-color: #f2f2f2
    position: absolute
    bottom:-.1rem
    left: -.2rem
  .nav_box>:last-child a::after
    display: none
</style>



// WEBPACK FOOTER //
// src/views/template1/FairDetail1.vue